import type { Taxas } from 'Model/ITaxa.ts'

export enum BlastSource {
  BOLD = 'BOLD',
  NCBI = 'NCBI',
  Silva = 'Silva',
  RDP = 'RDP',
  Consensus = 'Consensus'
}

export const TaxaBlastSources: Record<Taxas, BlastSource[]> = {
  _16S_BACTERIA: [BlastSource.Silva, BlastSource.NCBI, BlastSource.RDP],
  '16S_VERTEBRATES': [BlastSource.NCBI, BlastSource.RDP],
  '12S_FISH': [BlastSource.NCBI, BlastSource.RDP],
  CO1_ANIMAL: [BlastSource.NCBI, BlastSource.BOLD, BlastSource.RDP, BlastSource.Consensus],
  FITS2_FUNGAL: [BlastSource.NCBI, BlastSource.BOLD, BlastSource.RDP, BlastSource.Consensus],
  OTHER: [BlastSource.NCBI, BlastSource.BOLD, BlastSource.RDP, BlastSource.Consensus],
  PITS2_PLANT: [BlastSource.NCBI, BlastSource.BOLD, BlastSource.RDP, BlastSource.Consensus],
  custom_primer: [BlastSource.NCBI, BlastSource.BOLD, BlastSource.RDP, BlastSource.Consensus, BlastSource.Silva]
}

/**
 * The blast sources valid for at least one of [taxas] — all of them when none is known, so an
 * unresolved taxonomy offers too much rather than silently hiding a source the data has.
 *
 * Ordered by the enum so the picker does not reshuffle as samples load.
 */
export const blastSourcesForTaxas = (taxas: Array<Taxas | undefined | null>): BlastSource[] => {
  const known = taxas.filter((taxa): taxa is Taxas => !!taxa && taxa in TaxaBlastSources)
  if (known.length === 0) return Object.values(BlastSource)

  const union = new Set<BlastSource>(known.flatMap((taxa) => TaxaBlastSources[taxa]))
  return Object.values(BlastSource).filter((source) => union.has(source))
}

export const BlastSourcesRecord: Record<string, BlastSource> = {
  BOLD: BlastSource.BOLD,
  NCBI: BlastSource.NCBI,
  Silva: BlastSource.Silva,
  RDP: BlastSource.RDP,
  Consensus: BlastSource.Consensus
}
